import React from 'react';
import { motion } from 'framer-motion';
import { ItemType } from '../types/moodboard';
interface TypeFilterProps {
  activeFilter: ItemType | 'all';
  onFilterChange: (filter: ItemType | 'all') => void;
  counts: Record<ItemType | 'all', number>;
}
export function TypeFilter({
  activeFilter,
  onFilterChange,
  counts
}: TypeFilterProps) {
  const filters: Array<{
    value: ItemType | 'all';
    label: string;
  }> = [{
    value: 'all',
    label: 'TUTTI'
  }, {
    value: 'image',
    label: 'IMMAGINI'
  }, {
    value: 'note',
    label: 'NOTE'
  }, {
    value: 'color_palette',
    label: 'PALETTE'
  }, {
    value: 'link',
    label: 'LINK'
  }];
  return <div className="border-b border-border bg-white sticky top-16 sm:top-20 z-30" data-id="element-284">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 py-3 sm:py-4" data-id="element-285">
        <div className="flex items-center gap-2 sm:gap-3 overflow-x-auto pb-4 sm:pb-0 hide-scrollbar" data-id="element-286">
          {filters.map(filter => {
          const isActive = activeFilter === filter.value;
          return <button key={filter.value} onClick={() => onFilterChange(filter.value)} className={`relative font-heading text-[10px] tracking-[0.2em] uppercase px-4 py-2 border transition-all rounded-full whitespace-nowrap ${isActive ? 'border-black bg-black text-white' : 'border-border text-[#666] hover:border-black hover:text-black'}`} data-id="element-287">
                {filter.label}
                <span className={`ml-2 font-mono text-[9px] ${isActive ? 'text-white/70' : 'text-[#999]'}`} data-id="element-288">
                  {counts[filter.value] || 0}
                </span>
              </button>;
        })}
        </div>
      </div>
    </div>;
}